module.exports = __webpack_public_path__ + "static/img/del.ea89b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/del.png
// module id = Ub/c
// module chunks = 1